// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","container":"GeneralButton-module--container--24_L7","disabled":"GeneralButton-module--disabled--SxEKu","outline":"GeneralButton-module--outline--2Ab51"};